module.exports = __webpack_public_path__ + "img/sp.c7c34a29.png";